module.exports = __webpack_public_path__ + "img/feature-get-insights.f8530095.svg";